import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useUpdateProjectContributors = (projectId, contributorId) => {
  const fetchContext = useContext(FetchContext);
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      await fetchContext.authAxios.put(
        `/projects/${projectId}/contributors/${contributorId}`,
        data
      );
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(["project", projectId, "contributors"]);
      },
    }
  );
};
